const config = {};

function json (response) {
    return response.json();
}

export default function getConfiguration() {
    return new Promise((resolve, reject) => {
        if (Object.keys(config).length > 0) {
            resolve(config);
        } else {
            fetch('/etc/designs/gotoIBS6/jslib/config.js')
                .then(json)
                .then(response => {
                    Object.assign(config, response);
                    resolve(config);
                })
                .catch(() => {
                    reject('Unable to retrieve the configuration file');
                });
        }
    });
}